import React from "react";
import PropTypes from "prop-types";
import screenfull from "screenfull";

import IconButton from "@mui/material/IconButton";
import FullScreenIcon from "@mui/icons-material/Fullscreen";
import FullScreenExitIcon from "@mui/icons-material/FullscreenExit";
import SettingsIcon from "@mui/icons-material/Settings";
import Tooltip from "@mui/material/Tooltip";

import { SINGLE_PER_PAGE, DOUBLE_PER_PAGE } from "~/constants/page-modes";
import SinglePerPageIcon from "~/components/Icon/SinglePerPageIcon";
import DoublePerPageIcon from "~/components/Icon/DoublePerPageIcon";
import IconGallery from "~/components/IconGallery";
import InlineToolbar from "~/components/InlineToolbar";
import { styled } from "@mui/material/styles";

const StyledIconButton = styled(IconButton)(({ theme }) => {
  return {
    "&:focus-visible": {
      outline: theme.outline(),
      outlineOffset: "-2px"
    }
  };
});

function PageControls({
  pageMode,
  setPageMode,
  showFullScreenButton,
  toggleFullScreen,
  isFullScreen,
  showPageModeButton,
  isStudentMode,
  isDlsMode,
  isManualPageControl,
  showModal,
  usersettings
}) {
  function openUserSettings() {
    showModal("USERSETTINGS", { usersettings });
  }

  console.log(isDlsMode, usersettings, usersettings.length);

  return (
    <InlineToolbar>
      {screenfull.isEnabled && showFullScreenButton && (
        <Tooltip title="Vollbild">
          <StyledIconButton
            onClick={toggleFullScreen}
            size="large"
            aria-label={isFullScreen ? "Vollbild verlassen" : "Vollbild"}
          >
            {isFullScreen ? <FullScreenExitIcon /> : <FullScreenIcon />}
          </StyledIconButton>
        </Tooltip>
      )}
      {isDlsMode && usersettings && usersettings.length > 0 && (
        <Tooltip title="Material-Einstellungen">
          <StyledIconButton onClick={openUserSettings} size="large" aria-label="Material-Einstellungen">
            <SettingsIcon />
          </StyledIconButton>
        </Tooltip>
      )}
      {(isStudentMode || isManualPageControl) && showPageModeButton && (
        <IconGallery label="Ansicht" active={true} value={pageMode} onChange={setPageMode}>
          <SinglePerPageIcon value={SINGLE_PER_PAGE} label="Eine Seite" />
          <DoublePerPageIcon value={DOUBLE_PER_PAGE} label="Zwei Seiten" />
        </IconGallery>
      )}
    </InlineToolbar>
  );
}

PageControls.propTypes = {
  pageMode: PropTypes.number,
  setPageMode: PropTypes.func.isRequired,
  showFullScreenButton: PropTypes.bool.isRequired,
  toggleFullScreen: PropTypes.func.isRequired,
  isFullScreen: PropTypes.bool.isRequired,
  showPageModeButton: PropTypes.bool.isRequired,
  isStudentMode: PropTypes.bool.isRequired,
  isDlsMode: PropTypes.bool.isRequired,
  isManualPageControl: PropTypes.bool.isRequired,
  showModal: PropTypes.func.isRequired,
  usersettings: PropTypes.array.isRequired
};

export default PageControls;
